import {Splide} from '@splidejs/splide';

export function initServicesSlider() {
    const sliders = document.querySelectorAll('[data-services-slider]');

    if (!sliders.length || typeof Splide === 'undefined') return;

    sliders.forEach((slider) => {
        const wrapper = slider.closest('.services-slider-section__slider');
        const prevButton = wrapper?.querySelector('[data-services-slider-prev]');
        const nextButton = wrapper?.querySelector('[data-services-slider-next]');

        const instance = new Splide(slider, {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            gap: 25,
            arrows: false,
            pagination: false,
            drag: true,
            speed: 700,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            breakpoints: {
                1439: {
                    gap: 20,
                },
                1199: {
                    perPage: 3,
                    gap: 20,
                },
                991: {
                    perPage: 2,
                    gap: 20,
                },
                575: {
                    perPage: 1,
                    gap: 15,
                },
            },
        });

        const updateArrows = () => {
            if (!prevButton || !nextButton) {
                return;
            }

            const isOverflow = slider.classList.contains('is-overflow');
            const end = instance.Components.Controller.getEnd();

            prevButton.hidden = !isOverflow;
            nextButton.hidden = !isOverflow;
            prevButton.disabled = instance.index <= 0;
            nextButton.disabled = instance.index >= end;
        };

        if (prevButton) {
            prevButton.addEventListener('click', () => instance.go('<'));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => instance.go('>'));
        }

        instance.on('mounted move updated resize', updateArrows);
        instance.mount();
    });
}
